import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Form, Label } from 'semantic-ui-react';
import * as cardValidator from 'card-validator';

const PaymentInformationCredit = ({ source, onChange, collectSecurityCode, collectZipCode, showErrors }) => {
	const { cardNumber, cardExpireMonth, cardExpireYear, nameOnCard, zipCode, securityCode } = source;

	const cardNumberValid = useMemo(() => cardNumber === '' || cardNumber === null || (cardNumber !== '' && cardValidator.number(cardNumber).isValid), [cardNumber]);
	const cardNumberPotentiallyValid = useMemo(() => cardNumber === '' || cardNumber === null || (cardNumber !== '' && cardValidator.number(cardNumber).isPotentiallyValid), [cardNumber]);

	const months = useMemo(
		() =>
			Array.from(Array(13).keys())
				.slice(1)
				.map((o) => {
					return { text: o, value: o };
				}),
		[]
	);

	const years = useMemo(
		() =>
			Array.from(Array(10).keys())
				.map((o) => o + new Date().getFullYear())
				.map((o) => {
					return { text: o, value: o };
				}),
		[]
	);

	return (
		<React.Fragment>
			<Form.Field>
				<label>Card Number</label>
				<Form.Input required name='cardNumber' placeholder='Card Number' value={cardNumber || ''} onChange={onChange} error={!cardNumberValid || !cardNumberPotentiallyValid || (showErrors && !cardNumber)} type='number' />
				{!cardNumberValid && !cardNumberPotentiallyValid && (
					<Label pointing prompt color='red'>
						Incorrect number entered. Please check and re-enter to proceed with payment.
					</Label>
				)}
			</Form.Field>
			<Form.Group>
				<Form.Dropdown required name='cardExpireMonth' compact selection options={months} label='Expiration Month' defaultValue={cardExpireMonth} onChange={onChange} error={showErrors && !cardExpireMonth} value={cardExpireMonth} />
				<Form.Dropdown required name='cardExpireYear' compact selection options={years} label='Expiration Year' defaultValue={cardExpireYear} onChange={onChange} error={showErrors && !cardExpireYear} value={cardExpireYear} />
			</Form.Group>
			<Form.Input required name='nameOnCard' label='Name on Card' placeholder='Name on Card' value={nameOnCard || ''} onChange={onChange} error={showErrors && !nameOnCard} />
			{collectSecurityCode && <Form.Input required name='securityCode' label='Security Code' placeholder='Security Code' value={securityCode || ''} onChange={onChange} type='password' error={showErrors && !securityCode} />}
			{collectZipCode && <Form.Input required name='zipCode' label='ZIP Code' placeholder='ZIP Code' value={zipCode || ''} onChange={onChange} error={showErrors && !zipCode} type='number' />}
		</React.Fragment>
	);
};

PaymentInformationCredit.propTypes = {
	source: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired,
	loading: PropTypes.bool,
};

export default PaymentInformationCredit;
